<!-- 填寫　用品請領申請表　--->

<template>

  <div>
  <el-row :gutter="20" class="top-block">
    <Breadcrumb :route="this.$route"></Breadcrumb>
  </el-row>

  <el-row v-if="!editMode">
    <el-col :xs="8" :sm="8" :lg="12">
      
      <el-button v-if="from==''" type="normal" @click.prevent="goBack" class="ml-20" circle><i class="el-icon-d-arrow-left"></i>
      </el-button>
      <el-button v-if="from !=''" type="info" @click.prevent="goBackReport" class="ml-20" circle><i class="el-icon-d-arrow-left"></i>
      </el-button>
    </el-col>
    <el-col :xs="16" :sm="16" :lg="12" style="text-align: right">
      <el-button v-if="canEdit" type="warning" @click.prevent="handleDraft">暫存 <i
          class="el-icon-s-claim"></i></el-button>

      <template v-if="basicForm.status === 'close'">
        <el-popconfirm
          confirm-button-text="確定"
          cancel-button-text="取消"
          icon="el-icon-info"
          icon-color="red"
          title="確定作廢此筆資料嗎?"
          @confirm="handleInvalid(form.mytodoId)"
        >
          <el-button size="mini" type="danger" slot="reference" class="mr-10">作廢此單</el-button>
        </el-popconfirm>
      </template>

      <el-button v-if="canEdit" type="primary" @click.prevent="handleSign()" class="mr-20">送簽核 <i
          class="el-icon-s-claim"></i></el-button>
    </el-col>
  </el-row>

  

    <!-------------------------------------------------------------------->
    <!-- form -->
    <!-------------------------------------------------------------------->

    <!--    基本資料-->
  <el-row v-if="!editMode">
    <el-col :xs="24" :sm="24" :lg="24" class="mt-20">
      <el-main>
        <el-card class="box-card">
          <div slot="header" class="clearfix">
            <span>基本資料</span>
            <el-button style="float: right; padding: 2px 0; margin-top: -12px" type="text"><el-tag type="info">{{basicForm.status | fmtSignResult }}</el-tag></el-button>
          </div>
          <div>
            <el-form :model="basicForm" :rules="rules" ref="basicDataForm" label-width="50px">
              <el-row>
                <el-col :xs="12" :sm="12" :md="12">
                  <p>填單人: {{basicForm.userObj.username}} </p>
                </el-col>
                <el-col :xs="12" :sm="12" :md="12">
                  <p>申請日期: {{basicForm.startDate | fmtDate}}</p>
                </el-col>
              </el-row>
              <el-row>
                <el-col :xs="24" :sm="24" :md="24">
                  <p class="mt-20">標題: {{basicForm.title}} </p>
                </el-col>
              </el-row>
              <el-row>
                <el-col :xs="24" :sm="24" :md="24">
                  <p class="mt-20">請領單編號: {{basicForm.reqPayNo}} </p>
                </el-col>
              </el-row>
            </el-form>

            <!-- <el-form :model="basicForm" :rules="rules" ref="basicDataForm" label-width="100px">
              <el-row>
                <el-col :xs="24" :sm="24" :md="8">
                  <el-form-item label="填單人" prop="userObj.username" >
                    <el-input  readonly v-model="basicForm.userObj.username"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :xs="24" :sm="24" :md="8">
                  <el-form-item label="標題" prop="title">
                    <el-input readonly　v-model="basicForm.title" autocomplete="off"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :xs="24" :sm="24" :md="8">
                  <el-form-item label="報表日期" prop="startDate" >
                    <el-date-picker readonly　type="date" placeholder="選擇日期" v-model="basicForm.startDate"></el-date-picker>
                  </el-form-item>
                </el-col>
                <el-col :xs="24" :sm="24" :md="8">
                  <el-form-item label="請領單編號" prop="reqPayNo" >
                    <el-input  readonly v-model="basicForm.reqPayNo"></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
            </el-form> -->
          </div>
        </el-card>
      </el-main>
    </el-col>
  </el-row>

   
    <!--    請領項目 -->
  <el-row v-if="!editMode">
    <el-col :xs="24" :sm="24" :lg="24"  class="mt-20">
      <el-main class="mymain">
        <el-card class="box-card">
          <div slot="header" class="clearfix">
            <span>請領項目</span>
            <el-button v-if="basicForm.status === 'draft'" style="float: right; padding: 5px 12px" 　type="primary"
                       @click.prevent="handleAddTask" id="add_task_btn"><i class="el-icon-circle-plus-outline"></i> 新增請領項目 </el-button>
          </div>
          <div>
            
            <el-table :data="task.tableData" empty-text="無資料" stripe　:default-expand-all="true" style="width: 100%;">
              <el-table-column label="項次 類型" min-width="18%">
                  <template slot-scope="scope">
                    {{scope.$index+1}}. {{scope.row.itemType}}
                  </template>
              </el-table-column>
              <el-table-column label="名稱" prop="itemName" min-width="20%">
              </el-table-column>
              <el-table-column label="請領數" prop="itemQty" min-width="15%"></el-table-column>

              <el-table-column label="操作" min-width="25%" v-if="canEdit">
                <template slot-scope="scope">

                  <el-button type="primary" circle @click="handleEdit(scope.row)"><i class="el-icon-edit"></i></el-button>

                  <el-popconfirm
                      class="ml-10 popconfirm-bg"
                      title="確定刪除此筆資料嗎?"
                      confirm-button-text="確定"
                      cancel-button-text="取消刪除"
                      icon="el-iconf-info"
                      icon-color="red"
                      @confirm="taskHandleDeleteHistory(scope.row.id)"
                  >
                    <el-button type="danger" slot="reference" circle><i class="el-icon-delete"></i></el-button>
                  </el-popconfirm>
                </template>
              </el-table-column>


            </el-table>

          </div>
        </el-card>
      </el-main>
    </el-col>
  </el-row>



    <!--    簽核紀錄-->
    <SignOffHistory :editMode="editMode" :canViewSignOff="canViewSignOff"></SignOffHistory>




   <!-- ############################################################################# -->
   <!-- ####### 輸入表單　################################################ -->
   <!-- ############################################################################# -->

    <el-row v-if="editMode" style="background-color: white; padding:20px 8px">
      <div v-if="canViewAll === 'Y'">
        <el-select v-model="selectedArea" placeholder="地區" @change="handleArea">
          <el-option v-for="t in areaOptions"
                     :key="t.id"
                     :label="t.label"
                     :value="t.value"></el-option>
        </el-select>
      </div>
      

      <el-badge　class="item mr-10 mt-10">
        <el-button size="small" @click.prevent="handleTag('all')">全部</el-button>
      </el-badge>
      <el-badge class="item mr-10 mt-10" v-for="opt in typeOptions" :key="opt.id" >
        <el-button size="small" @click.prevent="handleTag(`${opt.id}`)">{{opt.value}}</el-button>
      </el-badge>

      <p>&nbsp;</p>
      
          
        <el-form class="myform" label-position="top" :model="itemForm" ref="itemForm" id="itemForm">
          <table style="width:100%">
            <tr>
              <td width="5%">no.</td>
              <td width="15%" v-if="canViewAll === 'Y'">地區</td>
              <td width="20%">類型</td>
              <td width="30%">名稱</td>
              <td width="15%">庫存數</td>
              <td width="15%">申請數</td>
            </tr>
            <tr>
              <td colspan="6">
                <el-row v-for="item,i in itemForm.count" :key="i" style="background-color: #f4f4f5; padding: 8px; margin-top: 8px;">
                  <el-col >
                      <el-form-item>
                        <table style="width:100%">
                          <tr>
                            <td width="5%">{{i+1}}.</td>
                            <td width="15%" v-if="canViewAll === 'Y'">
                              <span>{{itemForm.area[i]}}</span>
                            </td>
                            <td width="20%">
                              {{itemForm.itemTypeLabel[i]}}
                            </td>
                            <td width="30%">{{itemForm.itemName[i]}}</td>
                            <td width="15%">{{itemForm.stock[i]}}</td>
                            <td width="15%">
                              <el-input v-model="itemForm.itemQty[i]" autocomplete="off" style="width: 55px;"></el-input>
                            </td>
                          </tr>
                        </table>
                      </el-form-item>
                    </el-col>
                </el-row>
              </td>
            </tr>
          </table>
        </el-form>
      
      

      <div style="float: right;" class="mt-20">
        <el-button @click="cancelAddItem">取 消</el-button>
        <el-button type="primary" @click="itemFormSave('itemForm')">確 定</el-button>
      </div>
    </el-row>

    <el-row>
      <el-dialog title="修改用品數量"
                 :visible.sync="itemUpdateDialog"
                 :width="dw">

          <el-form label-position="top" :model="itemUpdateForm" ref="itemUpdateForm" id="itemUpdateForm">
            <tr>
              <td width="20%">類別</td>
              <td width="25%">用品名稱</td>
              <td width="15%">庫存數</td>
              <td width="20%">申請數</td>
            </tr>
            <el-form-item >
              <tr>
                <td width="20%">
                  <span v-if="canViewAll === 'Y'">{{itemUpdateForm.area}}-</span>
                  {{itemUpdateForm.itemTypeLabel}}
                </td>
                <td  width="40%">{{itemUpdateForm.itemName}}</td>
                <td  width="20%">{{itemUpdateForm.stock}}</td>
                <td  width="20%">
                  <el-input v-model="itemUpdateForm.itemQty" autocomplete="off" style="width: 55px;"></el-input>
                </td>
              </tr>
            </el-form-item>

              <!-- <el-form-item >
                <p>{{itemUpdateForm.area}}({{itemUpdateForm.itemTypeLabel}}){{itemUpdateForm.itemName}}, 庫存數量:{{itemUpdateForm.stock}} </p>
              </el-form-item>
              
              <el-form-item label="請領數量" style="margin-top: -20px;">
                <el-input-number  v-model="itemUpdateForm.itemQty" :min="0" :max="itemUpdateForm.stock"></el-input-number>
              </el-form-item>
 -->
          </el-form>
          <div slot="footer" class="dialog-footer">
            <el-button @click="itemUpdateDialog = false">取 消</el-button>
            <el-button type="primary" @click="itemUpdateFormSave()">確 定</el-button>
          </div>
       </el-dialog>
    </el-row>

    <el-row>
      <el-dialog title="附件圖"
                 :visible.sync="img.dialog"
                 :width="dw">
          <div class="demo-image">
            <el-image
              style="width: 100%; max-width: 100%; height: 100%;"
              :src="img.url"
              fit="cover" lazy>
                <div slot="placeholder" class="image-slot">
                <i class="el-icon-loading"></i> 開啟中...
              </div>
              </el-image>
          </div>
       </el-dialog>
    </el-row>

  </div>

</template>

<script>
import Breadcrumb from "@/components/breadcrumb/Breadcrumb";
import {mapState} from 'vuex'
import debounce from 'lodash/debounce'
import dayjs from "dayjs";
import SignOffHistory from '@/components/signoff/sign-history'

export default {
  name: "ReqItemPage",
  components: {
    Breadcrumb, SignOffHistory
  },
  data() {
    let checkName = (rule, value, callback) => {
      if (value === '' || value === null || typeof value === 'undefined') {
        callback(new Error('請輸入資料'))
      } else {
        callback()
      }
    }
    let treeCheck = (rule, value, callback) => {
      let selectedIds = this.$refs.tree.getCheckedKeys();

      if (!selectedIds || selectedIds.length === 0) {
        callback(new Error('請確認出勤前工作'))
      } else {
        callback()
      }
    }

    return {
      from:'',
      itemUpdateDialog: false,

      typeOptions:[],

      editMode: false,
      actionType: '',

      img:{
        dialog: false,
        url:''
      },
      
      props: {
        label: 'name'
      },
      historyTableData: [],
      precheckListOption: [],

      itemApplyForm:{
        qty:[],
        item:[],
      },

      tableHeader:[],
      selectedArea:'',

      task: {
        tableData:[],
        dialog: false,
        form: {
          mytodoId: '',
          id:'',
          fileList:[],
          fileNotes:[],
          itemName:'',
          itemQty: 1,
          itemId:''
        },
        btnCount:0,
        taskTypeOptions:[],

        availableItems:[],
        itemsCount:0
      },

      availableItems:[],
      filteredTableData:[],

      itemForm:{
        mytodoId:'',
        count:0,
        itemTypeLabel:[],
        itemName:[],
        itemType:[],
        stock:[],
        itemQty:[],
        area:[],
        itemId:[]
      },
      // itemForm: {
      //   mytodoId:'',
      //   itemType:[],
      //   itemName:[],
      //   itemQty:[]
      // },

      requestCount:[],

      basicForm: {
        id: '',
        title: '',
        startDate: '',
        userObj: {
          username:''
        },
        status:'',
        endDate: '',
        preCheckItem: '',
        preCheckTree:[],
        visitRoute: '',
        itemSum:0,
        tax:0,
        taxPrice:0,
        totalPrice:0

      },
      visitForm: {
        customerId: '',
        arrivalTime: '',
        deliveryContent: [],
        serviceContent: [],
        paymentReceive: [],
        notes: '',
        fileList: []
      },
      itemUpdateForm:{
        itemQty: 0,
        area: '',
        itemTypeLabel: '',
        itemName: '',
        stock: 0
      },
      inputValue:'',
      inputVisible:false,
      dynamicTags:[],

      loading: false,
      dw: '60%',
      fileList: [],
      preCheckOption: [],
      precheckList: [],
      tableData: [],
      options: [],
      queryField: '',
      keyword: '',
      pageNum: 1,
      pageSize: 10,
      total: 0,
      dialogFormVisible: false,
      formLabelWidth: '',
      deliveryContentOptions: ['送店', '指送'],
      shippingToDifferentAddress: false,
      serviceContentOptions: ['補目錄', '做宣傳', '交流','收退料', '放帳單'],
      paymentReceiveOptions: ['現金', '期票'],
      btnCount: 0,
      form: {
        mytodoId: '',
        custId: '',
        arrivalTime: '',
        deliveryContentChecked: [],
        deliveryContent: '',
        serviceContentChecked: [],
        serviceContent: '',
        paymentReceiveChecked: [],
        paymentReceive: '',
        notes: '',
        fileList: [],
        fileNotes: []
      },

      canViewAll:'N',

      areaOptions:[
        {value: '北區', label: '北區'},
        {value: '中區', label: '中區'},
        {value: '南區', label: '南區'}
      ],

      rules: {
        title: [{validator: checkName, trigger: 'change'}],
        startDate: [{validator: checkName, trigger: 'change'}]
      },
      visitRules: {
        preCheckTree:[{validator: treeCheck, trigger: 'change'}],
        visitRoute: [{validator: checkName, trigger: 'change'}]
      },
      visitFormRules: {
        custId: [{required: true, validator: checkName, trigger: 'change'}],
        arrivalTime: [{required: true, validator: checkName, trigger: 'change'}],
        customerRecord: [{required: true, validator: checkName, trigger: 'blur'}]
      },
      taskFormRule:{
        itemName: [{required:true, validator: checkName, trigger: 'change'}],
      }

    }
  },
  computed: {
    ...mapState('login', ['userInfo']),
    canEdit() {
      return this.basicForm.status === 'draft' || this.basicForm.status === 'reject'
    },
    canViewSignOff() {
      return this.basicForm.status === 'reject' || this.basicForm.status === 'close' || this.basicForm.status === 'review' || this.basicForm.status === 'invalid'
    },
  },
  methods: {
    queryItem(str, cb){
      this.request.get("/item/q?keyword=" + str).then(res => {
        if (res.code === '200') {
          let list = res.data.map((item) => {
            return {
              value: item.itemName,
              id: item.id
            }
          })
          cb(list)
        }
      })
    },
    
    showImage(uuid) {
      this.img.dialog = true
      this.img.url = this.displayAvatar(uuid)
    },
    
    removeHistoryUpdate(id) {
      this.request.delete("/todo/req-item/history/file/" + id).then(res => {
        if (res.code === '200') {
          this.taskLoadHistory()
          this.showResult('success', '資料刪除成功.')
        } else {
          this.showResult('error', '資料刪除失敗.')
        }
      })
    },

    cancelAddItem(){

      this.clearInputForm()

      this.editMode = false
      this.$nextTick(()=>{
        document.getElementById("add_task_btn").scrollIntoView({behavior: 'smooth', inline:'nearest'})
      })


      // this.editMode = false
      // this.actionType = ''
      // this.task.btnCount = 0
      // this.task.btnUpdateCount = 0

    },
    subTotalCalculate() {

      // let qty = this.task.form.itemQty
      // let price = this.task.form.itemPrice
      // this.task.form.itemSubTotal = qty * price

      // console.log('subTotalCalculate:', this.task.form.itemSubTotal)

    },
    closeTaskDialog() {
      //this.task.form.notes = ''
      this.$refs['taskForm'].resetFields()
      this.task.btnCount = 0
      //this.()
    },
    taskHandleUploadSuccess(res, file) {
      this.task.form.fileList.push(res.uuid)
    },
    taskNewUploadField() {
      this.task.btnCount++
    },
    taskHandleFileRemove(file, fileList) {
      this.task.form.fileList = this.task.form.fileList.filter(e => e !== file.response.uuid)
    },
    itemFormSave(formName){
      console.log(this.itemForm)

      let data = {
        mytodoId: this.itemForm.mytodoId,
        itemId:[],
        itemName:[],
        itemType:[],
        itemQty:[]
      }

      let counter = 0;
      for (let i = 0; i < this.availableItems.length; i++) {

        let qty = this.itemForm.itemQty[i];
        console.log('qty:', qty)
        // 有申請數
        if (qty > 0) {
          data.itemId[counter] = this.itemForm.itemId[i]
          data.itemName[counter] = this.itemForm.itemName[i]
          data.itemQty[counter] = this.itemForm.itemQty[i]
          data.itemType[counter] = this.itemForm.itemTypeLabel[i]
          counter++ 
        }
      }


      console.log('fdata:', data)
     



      this.request.post("/todo/req-item/history", data).then(res => {
          if (res.code === '200') {

            this.clearInputForm()
            this.editMode = false
            this.showResult('success', '資料更新成功')

            this.$nextTick(()=>{
                this.taskLoadHistory()
                document.getElementById("add_task_btn").scrollIntoView({behavior: 'smooth', inline:'nearest'})
            })

          } else {
            this.showResult('error', '資料更新失敗')
          }
        })
    },
    itemUpdateFormSave(){
      let url = "/todo/req-item/history/update?id="+this.itemUpdateForm.id+"&itemQty="+this.itemUpdateForm.itemQty
      console.log(url)
      this.request.post(url).then(res => {
          if (res.code === '200') {
            this.itemUpdateDialog = false
            this.taskLoadHistory()
            this.showResult('success', '資料更新成功')
          } else {
            this.showResult('error', '資料更新失敗')
          }
        })
    },
    taskUpdateFormSave(formName){
      this.$refs[formName].validate(async valid => {
        if (valid) {

          try {
            this.doSave(this.task.updateForm)

          } catch (e) {
            this.showResult('error', '資料更新失敗')
          }
        }
      })
    },
    doSave(form) {
        this.request.post("/todo/req-item/history", form).then(res => {
              if (res.code === '200') {

                this.clearInputForm()
                this.editMode = false
                this.showResult('success', '資料更新成功')

                this.$nextTick(()=>{
                    this.taskLoadHistory()
                    document.getElementById("add_task_btn").scrollIntoView({behavior: 'smooth', inline:'nearest'})
                })

              } else {
                this.showResult('error', '資料更新失敗')
              }
            })
    },
  
  
    handleSelectItem(item) {
      this.task.form.itemId = item.id
    },

    clearInputForm() {
      this.$refs['itemForm'].resetFields()
    },

    handleAddTask() {

      this.loadAllItem()

      this.task.form.id = null
      this.task.form.fileList = []
      this.task.form.fileNotes = []
      this.task.btnCount = 0

      this.editMode = true
      this.$nextTick(()=>{
        document.getElementById("itemForm").scrollIntoView({behavior: 'smooth', inline:'nearest'})
      })

      
    },  
    taskHandleDeleteHistory(id) {
      this.request.delete("/todo/req-item/history/" + id).then(res => {
        if (res.code === '200') {
          this.taskLoadHistory()
          this.showResult('success', '資料刪除成功.')
        } else {
          this.showResult('error', '資料刪除失敗.')
        }
      })
    },
    taskLoadHistory() {
      this.request.get("/todo/req-item/history/" + this.task.form.mytodoId).then(res => {
        if (res.code === '200') {
          this.task.tableData = res.data

          // let totalPrice = 0
          // this.task.tableData.forEach(obj => {
          //   totalPrice += parseInt(obj.itemSubTotal)
          // })
          // //產品加總
          // console.log('totalPrice:', totalPrice)
          // this.basicForm.totalPrice = totalPrice



          //this.recalculate()
        } else {
          this.showResult('error', '用品撈取失敗')
        }
      })
    },
    recalculate(){




      // let itemSum = this.task.form.itemSum
      // let tax = 0
      // if(this.task.form.tax === 1) {
      //   tax = 0.05
      // }
      //this.task.form.taxPrice = Math.round(itemSum * tax)
      // this.task.form.totalPrice = parseInt(itemSum)
    },

    //參數為勾選的值，array
    handleDeliveryChange(selectedItem){
      console.log(selectedItem)
      console.log(selectedItem.includes('指送'))
      if (selectedItem.includes('指送')) {
        this.shippingToDifferentAddress = true
      } else {
        this.shippingToDifferentAddress = false
      }
    },
    handleSelect(item) {
      this.form.custId = item.id
    },
    querySearch(str, cb){
      this.request.get("/customer/q?keyword=" + str).then(res => {
        if (res.code === '200') {
          let list = res.data.map((item) => {
            return {
              value: item.company + "(" + item.name + ")",
              id: item.id 
            }
          })
          cb(list)
        }
      })
    },
    handleClose(tag) {
        this.dynamicTags.splice(this.dynamicTags.indexOf(tag), 1);
      },
    showInput() {
        this.inputVisible = true;
        this.$nextTick(_ => {
          this.$refs.saveTagInput.$refs.input.focus();
        });
    },
    handleInputConfirm() {
      let inputValue = this.inputValue;
      if (inputValue) {
        this.dynamicTags.push(inputValue);
      }
      this.inputVisible = false;
      this.inputValue = '';
    },
    
    loadJobSignHistory() {
      this.request.get("/job/signoff/history/" + this.form.mytodoId).then(res => {
        if (res.code === '200') {
          this.historyTableData = res.data
        } else {
          this.showResult('error', '客戶拜訪簽核紀錄撈取失敗')
        }
      })
    },
    
    handleSubmitForm() {
      this.request.post("/todo", this.basicForm).then(res => {
        //console.log(res)
        if (res.code === '200') {
          this.formDefault()
          this.showResult('success', '資料更新成功.')
        } else {
          this.showResult('error', '資料更新失敗.')
        }
      })
    },
    handleDraft() {

      
      this.handleSubmitForm()
    },
    handleInvalid(id) {
      this.request.post("/todo/invalid/" + id).then(res => {
          if (res.code === '200') {
            this.$router.go()
            this.showResult('success', '資料作廢成功.')
          } else {
            this.showResult('error', '資料作廢失敗.')
          }
      })
    },
    handleSign() {
      this.$confirm('資料填寫已完成，按下「確定」後將呈主管簽核?', '提醒', {
            confirmButtonText: '確定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            this.basicForm.status = "review"
            this.request.post("/todo/signoff", this.basicForm).then(res => {
              if (res.code === '200') {
                this.showResult('success', '表單送簽核成功')
                this.$nextTick(()=>{
                    this.goBack()
                 })
              } else {
                this.showResult('error', '表單送簽核失敗')
              }
            })
          }).catch(() => {

          });
    },
    handleAdd() {
      this.dialogFormVisible = true
      this.form.id = null
      this.form.fileList = []
      this.form.fileNotes = []
      this.btnCount = 0
    },

    handleEdit(rowData) {
      //console.log('rowData:', rowData)
      console.log('this.availableItems:', this.availableItems)
      let itemId = rowData.itemId;
      let item = this.availableItems.find(i => i.id === itemId)
      console.log('item:', item)

      this.itemUpdateDialog = true
      this.itemUpdateForm = {
        id: rowData.id,
        itemQty: rowData.itemQty,
        area: item.area,
        itemTypeLabel: item.itemTypeLabel,
        itemName: item.itemName,
        stock: item.stock
      }
    },
    

    closeDialog() {
      this.form.notes = ''
      this.$refs['visitForm'].resetFields()
      //this.loadCustomerHistoryData()
    },
    setDialogWidth() {
      let windowSize = document.body.clientWidth;
      const defaultWidth = 400; // 預設寬度
      if (windowSize < defaultWidth) {
        this.dw = "90%";
      } else {
        this.dw = "60%"
      }
    },
    formDefault() {
      this.request.get("/todo/" + this.form.mytodoId).then(res => {
        if (res.code === '200') {
          this.basicForm = res.data

          // this.task.form.itemSum = res.data.itemSum
          // this.task.form.tax = res.data.tax
          // this.task.form.taxPrice = res.data.taxPrice
          // this.task.form.totalPrice = res.data.totalPrice
        } else {
          this.showResult('error', '撈資料失敗')
        }
      })
      this.form.userId = this.userInfo.id
      this.form.todoType = this.getTodoType()
    },
    getTodoType() {
      this.userInfo.id;
    },
    
    goBack() {
      this.$router.push('/daily/item')
    },
    
    goBackReport() {
      this.$router.push('/report/req-forms-statistic')
    },

    handleUploadSuccess(res, file) {
      this.form.fileList.push(res.uuid)
    },
    handleFileRemove(file, fileList) {
      this.form.fileList = this.form.fileList.filter(e => e !== file.response.uuid)
    },
    beforeUpload(file) {
      const isLt5M = file.size / 1024 / 1024 < 5;
      return isLt5M
    },
    
    
    newUploadField() {
      this.btnCount++
    },

    loadTaskType() {
      let req = '/dic/type?queryField=item_type'
      this.request.get(req).then(res => {
        if (res.code === '200') {
          this.typeOptions = res.data
          console.log('this.typeOptions:', this.typeOptions)
        }
      })
    },

    handleItemClick(val) {
      console.log(val)
    },

    loadAllItem() {
      this.request.get("/item/all").then(res => {
        if (res.code === '200') {
          this.tableData = res.data
          this.availableItems = res.data;
          this.filteredTableData = res.data

          this.prepareItemBlock();
        }
      })
    },

    prepareItemBlock() {
      this.itemForm.count = this.filteredTableData.length
      for (let i = 0; i < this.filteredTableData.length; i++) {
          let item = this.filteredTableData[i]
          this.itemForm.itemId[i] = item.id
          this.itemForm.area[i] = item.area
          this.itemForm.itemTypeLabel[i] = item.itemTypeLabel
          this.itemForm.itemName[i] = item.itemName
          this.itemForm.stock[i] = item.stock
          this.itemForm.itemQty[i] = 0
        }
    },

    handleTag(item) {
      if (this.selectedArea !== '') {
        if (item === 'all') {
          this.filteredTableData = this.availableItems.filter(data => data.area == this.selectedArea)
        } else {
          this.filteredTableData = this.availableItems.filter(data => data.itemType == item && data.area == this.selectedArea)
        }
        
      } else {
        if (item === 'all') {
          this.filteredTableData = this.availableItems
        } else {
          this.filteredTableData = this.availableItems.filter(data => data.itemType == item)
        }
      }

      
      this.prepareItemBlock()
    },

    handleArea(){
      console.log(this.selectedArea)
      this.filteredTableData = this.availableItems.filter(data => data.area == this.selectedArea)
      this.prepareItemBlock()
    },

    userItemViewPermission(){
      
      this.request.get("/item/view/permission").then(res => {
        if (res.code === '200') {
          this.canViewAll = res.data
        }
      })
    }

  },
  filters: {
    signResult(value) {
      if (value === 'N') return '退回'
      if (value === 'Y') return '同意'
      if (value === 'cancel') return '取消'
      if (value === 'invalid') return '作廢'
    }
  },
  mounted() {
    this.form.mytodoId = this.$route.params.mytodoId
    this.task.form.mytodoId = this.$route.params.mytodoId
    this.itemForm.mytodoId = this.$route.params.mytodoId

    let from = this.$route.query.from
    if (typeof from === 'undefined') {
      this.from = ''
    } else {
      this.from = from
    }
    this.userItemViewPermission()

    this.loadAllItem()

    this.loadTaskType()


    this.loadJobSignHistory()

    //設定一些欄位預設值
    this.formDefault()
    
    this.setDialogWidth()

    this.taskLoadHistory()
  }
}
</script>

<style scoped>
.el-table {
  border-radius: 10px;
  padding: 20px;
}

.el-table >>> .headerStyle {
  /*background-color: #1e8fc6;*/
}

.el-popover.el-popper .el-popconfirm {
  background-color: black !important;
  padding: 10px !important;
}

.avatar-uploader {
  /*border: 1px dashed #d9d9d9;*/
  /*border-radius: 6px;*/
  cursor: pointer;
  position: relative;
  overflow: hidden;
  margin-bottom: 20px;
  text-align: center;
}

.avatar-uploader .el-upload:hover {
  border-color: #409EFF;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}

.avatar {
  width: 178px;
  height: 178px;
  display: block;
}

.display-avatar {
  width: 60px;
  height: 60px;
  border-radius: 999px;
}


/deep/ .el-upload-dragger {
  width: 180px !important;
}

.el-tag + .el-tag {
    margin-left: 10px;
  }
  .button-new-tag {
    margin-left: 10px;
    height: 32px;
    line-height: 30px;
    padding-top: 0;
    padding-bottom: 0;
  }
  .input-new-tag {
    width: 90px;
    margin-left: 10px;
    vertical-align: bottom;
  }

.myform >>> .el-form-item__label {
  padding: 0;
}



.el-main {
  padding: 0;
}
.el-form-item {
  margin-bottom: 12px;
}

.taskMain >>> .el-card__body {
  padding: 0;
}
.el-table {
  padding: 0;
}

.mymain >>> .el-card__body {
  padding: 0px;

}
</style>
